const strings = {
  title: 'Referência',
}

export default strings
